export default __webpack_public_path__ + "static/phonesmartfun-hand-c3f393e6f47c6250cc774c40eb2105c7.png";